// extracted by mini-css-extract-plugin
export var dropdownIcon = "_rv-6";
export var imgContainer = "_rv-3";
export var menuIcon = "_rv-5";
export var pillWrapper = "_rv-2";
export var pillsContainer = "_rv-1";
export var subscriptionCard = "_rv-0";
export var subscriptionLogo = "_rv-4";